(function () {
    const ELE_main_header = document.querySelector(".pd-header");
    const ELE_popup = document.querySelector(".pd-search-results-popup");
    const ELE_popup_cancel = document.querySelector(".pd-search-results-popup .btn-cancel");
    const ELE_popup_view_all = document.querySelector(".pd-search-results-popup .btn-view-all");
    const ELE_header_search_form = document.querySelector(".search-form");
    const ELE_header_search_input = document.querySelector(".pd-header__top #search-form");
    const ELE_header_search_input_mobile = document.querySelector(".pd-header__search-bar #search-form");
    const ELE_popUp_search_input = document.querySelector(".pd-search-results-popup #search-form");
    const ELE_suggested_search = document.querySelector(".pd-search-results-suggested-searches");
    const ELE_product_results = document.querySelector(".pd-search-results-products");
    const ELE_product_results__grid = document.querySelector(".pd-search-results-products__items .pd-grid");
    const ELE_close_up_buttons = document.querySelectorAll('[data-close-search-popup]');

    // EVENT HANDLERS
    ELE_header_search_input?.addEventListener('keyup', e => {
        const keyPressed = e.key;
        if (keyPressed === "Enter") {
            return;
        }

        const val = e?.target?.value;
        showPopup(val);
    })

    ELE_header_search_input_mobile?.addEventListener('keyup', e => {
        const keyPressed = e.key;
        if (keyPressed === "Enter") {
            return;
        }

        const val = e?.target?.value;
        showPopup(val);
    })

    ELE_header_search_input_mobile?.addEventListener('focus', e => {
        showCloseButtons();
    })

    ELE_popUp_search_input?.addEventListener('keyup', e => {
        const keyPressed = e.key;
        if (keyPressed !== "Enter") {
            return;
        }

        handleSeach();
    })

    ELE_popup_cancel?.addEventListener('click', closePopup);
    ELE_close_up_buttons?.forEach(btn => btn.addEventListener('click', e => closePopup(e)));

    document.addEventListener('click', e => {
        if (!ELE_main_header.contains(e.target)) {
            closePopup();
        }
    })

    ELE_suggested_search.addEventListener('click', e => {
        if (e?.target?.classList.contains('list-link')) {
            const text = e.target.innerText;
            ELE_popUp_search_input.value = text;
            ELE_header_search_input.value = text;
            ELE_header_search_input_mobile.value = text;
            handleSeach();
        }
    })

    ELE_popup_view_all.addEventListener('click', e => {
        ELE_header_search_form.submit();
    })

    function showCloseButtons() {
        ELE_close_up_buttons.forEach(btn => btn.style.display = '');
    }

    function hideCloseButtons() {
        ELE_close_up_buttons.forEach(btn => btn.style.display = 'none');
    }


    // UTILITY FUNCTIONS
    function showPopup(val) {
        if (val) {
            ELE_popup.classList.add('open');
            ELE_main_header.classList.add('bg-overlay')
            ELE_main_header.classList.add('pd-overlay')
        }

        if (ELE_popUp_search_input) {
            ELE_popUp_search_input.value = val;
            ELE_popUp_search_input.focus();
        }

        showCloseButtons();
        // ELE_header_search_input.addEventListener('blur', closePopup);
    }

    function closePopup(e) {
        e?.preventDefault();
        ELE_header_search_input.value = '';
        ELE_header_search_input_mobile.value = '';
        ELE_popup.classList.remove('open');
        ELE_main_header.classList.remove('bg-overlay');
        ELE_main_header.classList.remove('pd-overlay');
        ELE_suggested_search.classList.add('open');
        ELE_product_results.classList.remove('open');
        document.body.classList.remove('ss__autocomplete--active');
        hideCloseButtons();
    }

    async function handleSeach() {
        // TODO: call search endpoint and show results
        const q = ELE_popUp_search_input.value;

        // TODO: remove once api is hooked up
        // show 10 placeholder product cards
        for (let index = 0; index < 10; index++) {
            const productRenderUrl = `/products/apline-pom-pom-beanie-raspberry-1?view=view`;
            fetch(productRenderUrl)
                .then(productResponse => productResponse.text())
                .then(productHtml => {
                    const wrapper = document.createElement('div');
                    wrapper.innerHTML = productHtml;
                    ELE_product_results__grid.append(wrapper);
                })
        }

        // display results section
        ELE_suggested_search.classList.remove('open')
        ELE_product_results.classList.add('open')
    }
})();